export const GET_SAVED_FILTERS_REQUEST = 'GET_SAVED_FILTERS_REQUEST'
export const GET_SAVED_FILTERS_FAILURE = 'GET_SAVED_FILTERS_FAILURE'
export const GET_SAVED_FILTERS_SUCCESS = 'GET_SAVED_FILTERS_SUCCESS'
export const SAVE_FILTER_REQUEST = 'SAVE_FILTER_REQUEST'
export const SAVE_FILTER_FAILURE = 'SAVE_FILTER_FAILURE'
export const SAVE_FILTER_SUCCESS = 'SAVE_FILTER_SUCCESS'
export const DELETE_FILTER_REQUEST = 'DELETE_FILTER_REQUEST'
export const DELETE_FILTER_FAILURE = 'DELETE_FILTER_FAILURE'
export const DELETE_FILTER_SUCCESS = 'DELETE_FILTER_SUCCESS'
export const RESET_FILTERS_REQUEST = 'RESET_FILTERS_REQUEST'
export const SET_FILTER_REQUEST = 'SET_FILTER_REQUEST'
